import React, { useEffect, useState, useRef } from 'react';
import { Avatar, message, Popover } from 'antd';
import { Link } from 'react-router-dom'; // useHistory
import { useSelector, useDispatch } from 'react-redux';
import FeatherIcon from 'feather-icons-react';
import { InfoWraper, UserDropDwon } from './auth-info-style'; // NavAuth
// import Message from './message';
import Notification from './notification';
import Mail from './mailpage';
import Settings from './settings';
import Support from './support';
import Calender from './calendar';
import Shortcuts from './addShortcuts'
import { ProfileIcon, PasswordIcon } from '../../Icons/Icons'; //  StaffIcon, AccountsIcon,
// import { Dropdown } from '../../dropdown/dropdown';
// import { logOut } from '../../../redux/authentication/actionCreator';
import { clearUserData } from '../../../redux/CrmReduxCalls/LocalDataReduxStore';
import Heading from '../../heading/heading';
// import { setEditCall } from '../../../redux/CrmReduxCalls/EditNavCtrl';
import PasswordPopup from '../../../container/dashboard/Popup/PasswordPopup';
import { Button } from '../../buttons/buttons';
import EditNavPopup from '../../../container/dashboard/Popup/EditNavPopup'
import { LogOutApi } from '../../../Api/Services/CommonApiService'
import { getByUserProfile } from '../../../Api/Services/UserApiService';

function AuthInfo() {
  const localData = useSelector((state) => state.localRedux);
  const Role = localData.role
  const storeSubcription = localData.subcription
  const loginToken = localStorage.getItem('cx_token');
  // const history = useHistory();
  const dispatch = useDispatch();
  // const [state, setState] = useState({
  //   flag: 'english',
  // });   
  const loadingRef = useRef(false);
  const [deleteClick, setDelteClick] = useState(false)
  const edit = useSelector((state) => state.edit.edit);
  const [emailId, setEmailId] = useState();
  const [firstName, setFirstName] = useState();
  const [lastName, setLastName] = useState();
  // const [companyName, setCompanyName] = useState();
  // const [companyRole, setcompanyRole] = useState();
  const [popup, setPopup] = useState(false)
  const [profilePic, setProfilePic] = useState()
  const [open, setOpen] = useState(false);
  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };
  // const { flag } = state;
  const urlPathname = window.location.pathname;
  const urlSearch = window.location.search;
  const combinedUrl = urlPathname + urlSearch;
  const SignOut = async () => {
    // e.preventDefault();
    if (loadingRef.current) return;
    loadingRef.current = true;
    setDelteClick(true)
    let hideMessage;
    const formData = {}
    try {
      hideMessage = message.loading("Loading...", 0);
      const response = await LogOutApi(formData)
      if (response.statusCode === 200) {
        hideMessage();
        message.success("Logout successful")
        setTimeout(() => {
          document.body.innerHTML = "";
          window.localStorage.removeItem('cx_token');
          window.localStorage.removeItem('cx_expiration');
          window.localStorage.removeItem('cx_lastActivityTime');
          dispatch(clearUserData());
          window.location.replace("/");
        }, 1200);
        // loadingRef.current = false;
        // setDelteClick(false)
      }
      else {
        hideMessage();
        loadingRef.current = false;
        setDelteClick(false)
        message.error("Logout Failed");
      }
    } catch (err) {
      hideMessage();
      loadingRef.current = false;
      setDelteClick(false)
      message.error("Logout Failed");
    }
  };
  const getUserDetail = async () => {
    if (loginToken !== null) {
      try {
        const userDetail = await getByUserProfile()
        setEmailId(userDetail.email);
        setFirstName(userDetail.firstName);
        setLastName(userDetail.lastName);
        setProfilePic(userDetail.profilePic)
        // setCompanyName(userDetail.companyName)
        // setcompanyRole(userDetail.companyRole)
      } catch (error) {
        message.error(error)
      }
    }
  }
  useEffect(() => {
    getUserDetail();
  }, []);

  const onSubmit = () => {
    setOpen(false);
    setPopup(true)
  }

  const [confirmPopup, setConfirmPopup] = useState(false)
  const [linkUrl, setLinkUrl] = useState()
  const handleChange = (url) => {
    if (storeSubcription?.isActive) {
      setOpen(false);
      if (edit) {
        setConfirmPopup(true)
        setLinkUrl(url)
      }
    }
    else {
      message.info("Your subscription is not active. Please renew to continue");
    }
  };
  const userContent = (
    <UserDropDwon>
      <div className="user-dropdwon">
        <div className='Info__design' style={{ display: "flex", alignItems: "center", minWidth: 0, }}>
          <figure className="user-dropdwon__info" style={{ margin: 0 }}>
            {profilePic !== null && profilePic !== undefined && profilePic !== "" ?
              < img src={profilePic} alt="profile" style={{ width: "45px", height: "45px", borderRadius: "50%", objectFit: "cover", flexShrink: 0 }} />
              :
              <span className='details_span_Tag UserIcon' style={{ width: "45px", height: "45px", marginRight: "15px", fontSize: "25px", flexShrink: 0, }}>
                {firstName && firstName.slice(0, 1).toUpperCase()}
              </span>
            }
            <figcaption style={{
              display: "flex",
              flexDirection: "column",
              overflow: "hidden", // 👈 keeps ellipsis responsive
            }}>
              <Heading as="h5" style={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}>{firstName} {lastName}</Heading>
              <div title={emailId} className='div-ellipsis entityemail' style={{
                fontSize: 12, color: "#adb4d2", overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}>{emailId}</div>
            </figcaption>
          </figure>
          {/* {Role !== "Super Admin" ? <>
            <div title={companyRole} style={{ display: "flex", fontSize: 12, fontWeight: "600", marginBottom: 5 }}><StaffIcon height='14' width='14' marginRight={5} marginTop={1} />{companyRole}</div>
            <div title={companyName} style={{ display: "flex", fontSize: 12, fontWeight: "600" }}><AccountsIcon height='12' width='12' marginRight={5} marginTop={1} />{companyName}</div></> : <></>} */}
        </div>

        <ul className="user-dropdwon__links">
          {Role !== "Super Admin" ?
            <li>
              <Link to={(storeSubcription?.isActive && !edit) ? "/Home/profile-page" : combinedUrl} onClick={() => handleChange("/Home/profile-page")}>
                <ProfileIcon height={24} width={24} marginRight={10} /> Profile
              </Link>
            </li> : ""}
          <li>{
            (storeSubcription?.isActive && !edit) ?
              <Link to={combinedUrl} onClick={onSubmit}>
                <PasswordIcon height={24} width={24} marginRight={10} /> Change Password
              </Link> :
              <Link to={combinedUrl} style={{ cursor: "not-allowed" }}>
                <PasswordIcon height={24} width={24} marginRight={10} /> Change Password
              </Link>
          }
          </li>
        </ul>
        {/* <Link className="user-dropdwon__bottomAction" to="#" /> */}
        <div style={{ textAlign: "center" }}>
          <Button size="small" htmlType="submit" className="button_colors" onClick={SignOut} loading={deleteClick} disabled={deleteClick}>
            {!deleteClick && <FeatherIcon icon="log-out" />}Sign Out
          </Button>
          {/* </Link> */}
        </div>
      </div >
    </UserDropDwon >
  );
  // const onFlagChangeHandle = value => {
  //   setState({
  //     ...state,
  //     flag: value,
  //   });
  // };

  // const country = (
  //   <NavAuth>
  //     <Link onClick={() => onFlagChangeHandle('english')} to="#">
  //       <img src={require('../../../static/img/flag/english.png')} alt="" />
  //       <span>English</span>
  //     </Link>
  //     <Link onClick={() => onFlagChangeHandle('germany')} to="#">
  //       <img src={require('../../../static/img/flag/germany.png')} alt="" />
  //       <span>Germany</span>
  //     </Link>
  //     <Link onClick={() => onFlagChangeHandle('spain')} to="#">
  //       <img src={require('../../../static/img/flag/spain.png')} alt="" />
  //       <span>Spain</span>
  //     </Link>
  //     <Link onClick={() => onFlagChangeHandle('turky')} to="#">
  //       <img src={require('../../../static/img/flag/turky.png')} alt="" />
  //       <span>Turky</span>
  //     </Link>
  //   </NavAuth>
  // );

  return (
    <>
      <InfoWraper>
        {Role !== "Super Admin" ? <>
          <Shortcuts />
          <Mail />
          <Calender />
          {/* <Message /> */}
          <Notification />
          <Settings />
          <Support />
        </> : ""}
        {/* <div className="nav-author">
          <Dropdown placement="bottomRight" content={country} trigger="click">
            <Link to="#" className="head-example">
              <img src={require(`../../../static/img/flag/${flag}.png`)} alt="" />
            </Link>
          </Dropdown>
        </div> */}

        <div className="nav-author">
          <Popover
            placement="bottomRight"
            content={userContent}
            trigger="click"
            open={open}
            onOpenChange={handleOpenChange}
          >
            <Link to={combinedUrl} className="head-example">
              {profilePic !== null && profilePic !== undefined && profilePic !== "" ?
                <Avatar src={profilePic} alt="profile" />
                :
                <span className='details_span_Tag UserIcon' style={{ display: "flex", width: "32px", height: "32px", fontSize: "19px", color: "#272b41", background: "#bebfc6" }}>
                  {firstName && firstName.slice(0, 1).toUpperCase()}
                </span>
              }
            </Link>
          </Popover>
        </div>
      </InfoWraper>
      {popup && <PasswordPopup popup={popup} setPopup={setPopup} />}
      {confirmPopup && <EditNavPopup confirmPopup={confirmPopup} setConfirmPopup={setConfirmPopup} linkUrl={{ url: linkUrl, type: "Normal" }} />}
    </>
  );
}

export default AuthInfo;
